export default {"src":"/_next/static/media/gbyte.aded71ad.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};